export const getTranslation = (data?: Record<string, string>, language: string = 'en') => {
  if (!data) return '';

  return data[language] || data.en;
};
